import React from 'react'

const Profile = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/profile',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M3 18h14v-3.595c0-.69-.517-1.316-1.285-1.557C14.492 12.46 12.51 12 10 12s-4.493.46-5.714.847C3.505 13.094 3 13.705 3 14.405V18z'
        stroke={primaryColor}
        strokeWidth='1.2'
      />
      <path
        d='M9.97 2.18c1.565 0 2.837 1.322 2.837 2.947 0 1.657-1.31 3.683-2.837 3.683-1.528 0-2.838-2.026-2.838-3.683 0-1.625 1.273-2.947 2.838-2.947M10 10c2.253 0 4-2.605 4-4.846C14 2.863 12.206 1 10 1S6 2.863 6 5.154C6 7.394 7.747 10 10 10'
        fill={secondaryColor}
      />
    </g>
  </svg>
)

export default Profile
